import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 219 - 生命线效果
 * 219   气泡式效果 0: 气泡式效果开关(0: 关, 1: 开) 1,显示信息 2：帧数  3:X,Y,width,height(气泡式显示坐标、宽高)  4:对话框的路径 5:上、下、左、右边距
 */

export default class EventBubble extends EventBase {
  constructor() {
    super()
    this.Parameter = ['0', '1', '20', '0,0,960,540', '', '15,15,25,25']
  }

  public Code: EventID  = EventID.Bubble

  //   // #region 事件中主要属性参数
  /**
   * 生命线效果开关(0: 关 1: 开)
   */
  get IsOpen() {
    return this.Parameter && this.Parameter[0] === '1'
  }

  set IsOpen(val) {
    this.Parameter![0] = val ? '1' : '0'
  }

  /**
   * 现实信息，新版默认为1=
   */
  get Description() {
    return this.Parameter?.[1] || ''
  }

  set Description(val) {
    this.Parameter![1] = val
  }

  /**
   * 帧数
   */
  get FrameNumber() {
    return parseInt(this.Parameter?.[2] ?? '')
  }

  set FrameNumber(val) {
    this.Parameter![2] = val?.toString()
  }

  /**
   * x 坐标
   */
  get X() {
    return this.AnalysisEventStr(3, 0)
  }

  set X(val) {
    this.Parameter![3] =
      val.toString() + this.Y + this.ShowWidth + this.ShowHeight
  }

  /**
   * Y 坐标
   */
  get Y() {
    return this.AnalysisEventStr(3, 1)
  }

  set Y(val) {
    this.Parameter![3] =
      this.X + val.toString() + this.ShowWidth + this.ShowHeight
  }

  /**
   * 显示宽度
   */
  get ShowWidth() {
    return this.AnalysisEventStr(3, 2)
  }

  set ShowWidth(val) {
    this.Parameter![3] = this.X + this.Y + val.toString() + this.ShowHeight
  }

  get ShowHeight() {
    return this.AnalysisEventStr(3, 3)
  }

  set ShowHeight(val) {
    this.Parameter![3] = this.X + this.Y + this.ShowWidth + val.toString()
  }

  /**
   * 对话框路径
   */
  get DialogPath() {
    return this.Parameter?.[4] || ''
  }

  set DialogPath(val) {
    this.Parameter![4] = val
  }

  /**
   * 上边距
   */
  get MarginTop() {
    return this.AnalysisEventStr(5, 0)
  }

  set MarginTop(val) {
    this.Parameter![5] =
      '' + val + this.MarginBottom + this.MarginLeft + this.MarginRight
  }

  /**
   * 左边距
   */
  get MarginLeft() {
    return this.AnalysisEventStr(5, 2)
  }

  set MarginLeft(val) {
    this.Parameter![5] =
      '' + this.MarginTop + this.MarginBottom + val + this.MarginRight
  }

  /**
   * 右边距
   */
  get MarginRight() {
    return this.AnalysisEventStr(5, 3)
  }
  set MarginRight(val) {
    this.Parameter![5] =
      '' + this.MarginTop + this.MarginBottom + this.MarginLeft + val
  }

  /**
   * 下边距
   */
  get MarginBottom() {
    return this.AnalysisEventStr(5, 1)
  }
  set MarginBottom(val) {
    this.Parameter![5] =
      '' + this.MarginTop + val + this.MarginLeft + this.MarginRight
  }

  /**
   * 分析边距/坐标字符串
   * @param arrIndex 当前分析的是数组中的哪个元素
   * @param index 当前获取的是分析后数组的第几个
   * @returns 返回数值信息
   */
  public AnalysisEventStr(arrIndex: number, index: number): number {
    if (this.Parameter && this.Parameter[arrIndex]?.length) {
      const tempMargin = this.Parameter[arrIndex].split(',')
      if (tempMargin.length === 4) {
        return parseInt(tempMargin[index] ?? '0', 10)
      }
      return 0
    }
    return 0
  }
  //   // #endregion

}
